/**
 * DeleteImportFiles - Handles deletion of XML import files
 */
export class DeleteImportFiles {
    private button: HTMLElement | null = null;

    constructor() {
        this.init();
    }

    /**
     * Initialize the delete functionality
     */
    private init(): void {
        this.button = document.querySelector('.js-button-delete-import-files');

        if (this.button) {
            this.button.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleDeleteClick();
            });
        }
    }

    /**
     * Handle delete button click
     */
    private handleDeleteClick(): void {
        const confirmMessage = 'Möchten Sie wirklich alle XML-Import-Dateien löschen?\n\nDieser Vorgang kann nicht rückgängig gemacht werden!';

        if (confirm(confirmMessage)) {
            this.deleteFiles();
        }
    }

    /**
     * Perform the actual file deletion via AJAX
     */
    private deleteFiles(): void {
        // Disable button during request
        if (this.button) {
            this.button.setAttribute('disabled', 'disabled');
            this.button.textContent = 'Lösche...';
        }

        // Make AJAX request
        fetch('/Handler/HvD/CleanXmlFiles?action=delete', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(data => {
            const deletedCount = parseInt(data.trim());
            this.showResult(deletedCount);
        })
        .catch(error => {
            console.error('Error deleting files:', error);
            this.showError('Fehler beim Löschen der Dateien: ' + error.message);
        })
        .finally(() => {
            // Re-enable button
            this.resetButton();
        });
    }

    /**
     * Show success result
     */
    private showResult(deletedCount: number): void {
        let message: string;

        if (deletedCount === 0) {
            message = 'Keine XML-Dateien zum Löschen gefunden.';
        } else if (deletedCount === 1) {
            message = '1 XML-Datei wurde erfolgreich gelöscht.';
        } else {
            message = `${deletedCount} XML-Dateien wurden erfolgreich gelöscht.`;
        }

        alert(message);
    }

    /**
     * Show error message
     */
    private showError(message: string): void {
        alert(message);
    }

    /**
     * Reset button to original state
     */
    private resetButton(): void {
        if (this.button) {
            this.button.removeAttribute('disabled');
            this.button.textContent = 'XML-Dateien löschen';
        }
    }
}
